const SHORT_VIEWPORT = '@media (max-height: 620px)';

export const getHeroStyles =
  strong =>
  ({ palette }) => ({
    position: 'relative',
    flexShrink: 0,
    overflow: 'hidden',
    padding: '20px 22px',
    color: palette.common.white,
    backgroundColor: strong,
    backgroundImage:
      'radial-gradient(130% 130% at 100% -10%, rgba(255, 255, 255, 0.22), transparent 52%), ' +
      'linear-gradient(140deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.2) 120%)',

    [SHORT_VIEWPORT]: {
      padding: '10px 22px 12px',
    },
  });

// Decorative watermark digit on a plain Box (not TypographyCDS) — the CDS type
// scale tops out at 38px, so a 150px glyph has no variant; the override is local
// to this non-semantic element.
export const glyphStyles = {
  position: 'absolute',
  right: '-10px',
  top: '-24px',
  fontSize: '150px',
  fontWeight: 800,
  lineHeight: 1,
  letterSpacing: '-6px',
  color: 'rgba(255, 255, 255, 0.08)',
  userSelect: 'none',
  pointerEvents: 'none',
};

export const eyebrowStyles = {
  display: 'block',
  position: 'relative',
  textTransform: 'uppercase',
  opacity: 0.82,
};

export const titleStyles = {
  display: 'block',
  position: 'relative',
  margin: '6px 0 10px',

  [SHORT_VIEWPORT]: {
    margin: '2px 0 6px',
  },
};

export const pillStyles = {
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 12px',
  borderRadius: '999px',
  backgroundColor: 'rgba(255, 255, 255, 0.17)',
};

export const liveDotStyles = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: '#A9FFE4',
  boxShadow: '0 0 0 3px rgba(169, 255, 228, 0.3)',
  flexShrink: 0,
};

export const progressRowStyles = {
  position: 'relative',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: '12px',
  marginTop: '18px',

  [SHORT_VIEWPORT]: {
    marginTop: '8px',
  },
};

export const progressMetaStyles = {
  opacity: 0.88,
};

export const trackStyles = {
  position: 'relative',
  height: '8px',
  borderRadius: '999px',
  backgroundColor: 'rgba(255, 255, 255, 0.24)',
  overflow: 'hidden',
  marginTop: '10px',

  [SHORT_VIEWPORT]: {
    marginTop: '6px',
  },
};

export const getFillStyles = percentage => ({
  width: `${percentage}%`,
  height: '100%',
  borderRadius: '999px',
  backgroundImage: 'linear-gradient(90deg, #A9FFE4, #FFFFFF)',
});
